export const WORKSPACE_STORAGE_KEY = "union_workspace_region";

export const WORKSPACE_CN = "cn";
export const WORKSPACE_INTL = "intl";

/** BE 未返回或非法值时降级为 0（仅国内） */
export function normalizeDistributeIdentity(value) {
  const parsed = Number(value);
  if (parsed === 1 || parsed === 2) {
    return parsed;
  }
  return 0;
}

export function mapDistributeIdentityToWorkspace(distributeIdentity) {
  return normalizeDistributeIdentity(distributeIdentity) === 1 ? WORKSPACE_INTL : WORKSPACE_CN;
}

export function canUseWorkspace(distributeIdentity, workspace) {
  const identity = normalizeDistributeIdentity(distributeIdentity);
  if (identity === 0) {
    return workspace === WORKSPACE_CN;
  }
  if (identity === 1) {
    return workspace === WORKSPACE_INTL;
  }
  return workspace === WORKSPACE_CN || workspace === WORKSPACE_INTL;
}

export function shouldShowWorkspaceSwitcher(distributeIdentity) {
  return normalizeDistributeIdentity(distributeIdentity) === 2;
}

export function getDistributeIdentityLabel(distributeIdentity) {
  const identity = normalizeDistributeIdentity(distributeIdentity);
  if (identity === 1) {
    return "仅国际";
  }
  if (identity === 2) {
    return "国内/国际";
  }
  return "仅国内";
}

export function readStoredWorkspace() {
  try {
    const stored = localStorage.getItem(WORKSPACE_STORAGE_KEY);
    if (stored === WORKSPACE_CN || stored === WORKSPACE_INTL) {
      return stored;
    }
  } catch (error) {
    // ignore quota / private mode
  }
  return null;
}

export function resolveWorkspaceAfterBootstrap(accessInfo) {
  const distributeIdentity =
    accessInfo?.currentIdentity?.distributeIdentity ??
    accessInfo?.currentIdentity?.distribute_identity;
  const identity = normalizeDistributeIdentity(distributeIdentity);
  // 双域身份：尊重用户上次选择，避免 bootstrap 把 localStorage 覆写为国内
  if (identity === 2) {
    return resolveWorkspaceOnRefresh(distributeIdentity, readStoredWorkspace());
  }
  return mapDistributeIdentityToWorkspace(distributeIdentity);
}

export function resolveWorkspaceAfterSwitch(accessInfo) {
  return resolveWorkspaceAfterBootstrap(accessInfo);
}

/** 刷新 / 深链：localStorage 合法且当前身份允许时恢复 */
export function resolveWorkspaceOnRefresh(distributeIdentity, storedWorkspace) {
  const identity = normalizeDistributeIdentity(distributeIdentity);
  if (identity === 0) {
    return WORKSPACE_CN;
  }
  if (identity === 1) {
    return WORKSPACE_INTL;
  }
  if (storedWorkspace === WORKSPACE_CN || storedWorkspace === WORKSPACE_INTL) {
    return storedWorkspace;
  }
  return WORKSPACE_CN;
}
